(function ($, duo, undefined) {

	"use strict";

	/**
	 * @class Paragraphs
	 */
	class Paragraphs {

		/**
		 * Creates an instance of Paragraphs
		 */
		constructor() {
			// setup:
			this.setup();
		} /* constructor */

		setup() {

			// setup tables:
			this.initializeTables();

			// setup video paragraphs:
			this.initializeVideos();

			// setup sliders:
			this.initializeSliders();

		} /* setup */

		/**
		 * Setup tables in text paragraphs
		 */
		initializeTables() {
			const paragraphs = this;

			/*
			 * wrap the tables in a ".text-content" block inside an extra wrapper;
			 * we need to wrapper to be able to add scrollbars to the table on responsive
			 */

			$(document).find('.paragraph .text-content table').each(function (index, element) {
				const $table = $(element);
				$table.wrap('<div class="paragraph-table-wrapper"></div>');
			});

			/*
			 * if we need to scroll inside the table, we need to add a tabindex
			 * so the user can focus the table using the keyboard
			 */

			paragraphs._fixTableTabindex();
			// -> recalculate on resize (with debouncing):
			let timeout = false;
			$(window).on('resize.paragraphTables', function () {
				clearTimeout(timeout);
				timeout = setTimeout(paragraphs._fixTableTabindex(), 250);
			});
		} /* initializeTables */

		/**
		 * Fix table tabindex
		 */
		_fixTableTabindex() {
			$(document).find('.paragraph .text-content .paragraph-table-wrapper').each(function (index, element) {
				const $wrapper = $(element);
				const $table = $wrapper.find('> table');

				const wrapperWidth = $wrapper.width();
				const tableWidth = $table.width();

				if (tableWidth > wrapperWidth) {
					$wrapper.attr('tabindex', '0');
				} else {
					$wrapper.removeAttr('tabindex', '');
				}
			});
		} /* _fixTableTabindex */

		/**
		 * Setup video paragraphs
		 */
		initializeVideos() {

			/* setup fancybox */
			/* ************** */

			/* single video */
			/* ------------ */

			$('.js-paragraph-video-link').fancybox({
				loop: true,
				keyboard: true,
				arrows: true,
				infobar: false,
				toolbar: false,
				buttons: [],
				smallBtn: true,
				idleTime: 30,
				wheel: false,
				clickOutside: 'close',
				clickContent: false,
				animationEffect: 'fade',
				animationDuration: 500,
				transitionEffect: 'fade',
				transitionDuration: 366,
				media: {
					youtube: {
						params: {
							autoplay: 1,
							showinfo: 0
						}
					}
				},
				mobile: {
					clickSlide: function (current, event) {
						return current.type === 'image' ? 'close' : 'close';
					},
					clickContent: function (current, event) {
						return current.type === 'image' ? 'close' : 'close';
					},
				}
			});
		} /* initializeVideos */

		/**
		 * Setup sliders
		 */
		initializeSliders() {

			/* setup flickity */
			/* ************** */

			/* paragraph slider */
			$('.paragraph__slider').each(function (index, element) {
				const $sliderElement = $(element);

				// get the amount of slides:
				const nrOfSlides = $sliderElement.find('.paragraph__slider-item').length;
				// -> set options depending on the number of slides:
				const showPageDots = nrOfSlides > 1 ? true : false;
				const showNextButtons = nrOfSlides > 1 ? true : false;

				// console.log('.paragraph__slider');
				const flickitySlider = $sliderElement.flickity({
					cellSelector: '.paragraph__slider-item',
					imagesLoaded: true,
					arrowShape: 'M1.4,49.2a4.5,4.5,0,0,0,1.2,2.9L25.4,76.4c1.6,1.4,4.6,2,6.3.4a4.4,4.4,0,0,0-.1-6.2l-16-17.1H94.3a4.3,4.3,0,0,0,0-8.6H15.6l16-17.1a4.6,4.6,0,0,0,.1-6.2c-1.7-1.6-4.8-1.1-6.3.3L2.6,46.2a4.4,4.4,0,0,0-1.2,3Z'
				});
			});


			/* product slider */
			/* $('.product-slider__items').each(function (index, element) {
				const $productSliderElement = $(element);

				// get the amount of slides:
				const nrOfProductSlides = $productSliderElement.find('.product-slider__item').length;
				// -> set options depending on the number of slides:
				const productShowPageDots = nrOfProductSlides > 1 ? true : false;
				const productShowNextButtons = nrOfProductSlides > 1 ? true : false;

				const flickityProductSlider = $productSliderElement.flickity({
					cellSelector: '.product-slider__item',
					groupCells: true,
					imagesLoaded: true,
					adaptiveHeight: false,
					setGallerySize: true
				});

			}); */

			const $productSliderBlocks = $(document).find('.product-slider__items');
			$productSliderBlocks.each(function(index, element) {
				const $productSliderBlock = $(element);

				//const $productSliderElement = $(element);
				// get the amount of slides:
				//const nrOfProductSlides = $productSliderElement.find('.product-slider__item').length;
				// -> set options depending on the number of slides:
				//const productShowPageDots = nrOfProductSlides > 1 ? true : false;
				//const productShowNextButtons = nrOfProductSlides > 1 ? true : false;

				const $flickityProductSlider = $productSliderBlock.flickity({
					cellSelector: '.product-slider__item',
					groupCells: true,
					imagesLoaded: true,
					adaptiveHeight: false,
					setGallerySize: true
				});
			});

			/* inspiration slider */
			$('.inspiration-slider__items').each(function (index, element) {
				const isFront = $('body').hasClass('frontpage') ? true : false;
				const $inspirationSliderElement = $(element);

				const options = {
					cellSelector: '.inspiration-slider__item',
					groupCells: true,
					imagesLoaded: true
					/*arrowShape: 'M16.2,35.7 C16.5981203,35.9985902 17.1552148,35.9589987 17.5071068,35.6071068 C17.8589987,35.2552148 17.8985902,34.6981203 17.6,34.3 L3.3,19 L61,19 C61.5522847,19 62,18.5522847 62,18 C62,17.4477153 61.5522847,17 61,17 L3.3,17 L17.7,1.7 C18.0352958,1.29356009 18.0352958,0.706439907 17.7,0.3 C17.3111565,-0.0811428762 16.6888435,-0.0811428762 16.3,0.3 L0.3,17.3 C-0.0352958168,17.7064399 -0.0352958168,18.2935601 0.3,18.7 L16.2,35.7 Z'*/
				};

				if (isFront) {
					options.cellAlign = 'left';
				}

				// get the amount of slides:
				const nrOfInspirationSlides = $inspirationSliderElement.find('.inspiration-slider__item').length;
				// -> set options depending on the number of slides:
				const inspirationShowPageDots = nrOfInspirationSlides > 1 ? true : false;
				const inspirationShowNextButtons = nrOfInspirationSlides > 1 ? true : false;

				const flickityInspirationSlider = $inspirationSliderElement.flickity(options);

			});


			/* empty event listener: */
			/* -> the following is important - it makes flickity work better on ios
			 *    see: https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
			 *    "iOS 10 has a bug where event.preventDefault() will not cancel window scrolling.
			 *     You can fix this behavior by adding an innocuous event handler."
			 * -> when there's an update of flickity, this may no longer be needed
			 */
			window.addEventListener('touchmove', function () { });
		} /* initializeSliders */

	} /* Paragraphs */

	duo.Paragraphs = Paragraphs;

})(jQuery, window.duo = window.duo || {});
